import React from "react";

export function CandlestickIcon({ className = "w-6 h-6", bullish = true }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {bullish ? (
                <>
                    <line x1="8" y1="4" x2="8" y2="8" />
                    <rect x="6" y="8" width="4" height="8" fill="currentColor" />
                    <line x1="8" y1="16" x2="8" y2="20" />
                    <line x1="16" y1="2" x2="16" y2="6" />
                    <rect x="14" y="6" width="4" height="10" fill="currentColor" />
                    <line x1="16" y1="16" x2="16" y2="22" />
                </>
            ) : (
                <>
                    <line x1="8" y1="4" x2="8" y2="10" />
                    <rect x="6" y="10" width="4" height="6" />
                    <line x1="8" y1="16" x2="8" y2="20" />
                    <line x1="16" y1="2" x2="16" y2="8" />
                    <rect x="14" y="8" width="4" height="8" />
                    <line x1="16" y1="16" x2="16" y2="22" />
                </>
            )}
        </svg>
    );
}

export function TrendlineIcon({ className = "w-6 h-6", direction = "up" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {direction === "up" ? (
                <>
                    <line x1="3" y1="18" x2="21" y2="6" />
                    <circle cx="6" cy="16" r="1.5" fill="currentColor" />
                    <circle cx="12" cy="11" r="1.5" fill="currentColor" />
                    <circle cx="18" cy="8" r="1.5" fill="currentColor" />
                </>
            ) : (
                <>
                    <line x1="3" y1="6" x2="21" y2="18" />
                    <circle cx="6" cy="8" r="1.5" fill="currentColor" />
                    <circle cx="12" cy="11" r="1.5" fill="currentColor" />
                    <circle cx="18" cy="16" r="1.5" fill="currentColor" />
                </>
            )}
        </svg>
    );
}

export function ArrowUpIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <line x1="12" y1="19" x2="12" y2="5" />
            <polyline points="5 12 12 5 19 12" />
        </svg>
    );
}

export function ArrowDownIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <line x1="12" y1="5" x2="12" y2="19" />
            <polyline points="19 12 12 19 5 12" />
        </svg>
    );
}

export function ChartGridIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <rect x="3" y="3" width="18" height="18" rx="2" />
            <line x1="3" y1="9" x2="21" y2="9" />
            <line x1="3" y1="15" x2="21" y2="15" />
            <line x1="9" y1="3" x2="9" y2="21" />
            <line x1="15" y1="3" x2="15" y2="21" />
        </svg>
    );
}

export function SignalDotIcon({ className = "w-6 h-6", pulsing = false }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="currentColor"
            className={className}
        >
            {pulsing && (
                <circle cx="12" cy="12" r="8" opacity="0.3">
                    <animate
                        attributeName="r"
                        from="8"
                        to="11"
                        dur="1.5s"
                        repeatCount="indefinite"
                    />
                    <animate
                        attributeName="opacity"
                        from="0.3"
                        to="0"
                        dur="1.5s"
                        repeatCount="indefinite"
                    />
                </circle>
            )}
            <circle cx="12" cy="12" r="5" />
            <circle cx="12" cy="12" r="2" opacity="0.5" />
        </svg>
    );
}

export function AnalyticsLineIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <polyline points="3 17 9 11 13 15 21 7" />
            <polyline points="14 7 21 7 21 14" />
        </svg>
    );
}

export function VolumeBarIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <rect x="3" y="14" width="3" height="7" fill="currentColor" opacity="0.6" />
            <rect x="8" y="10" width="3" height="11" fill="currentColor" opacity="0.7" />
            <rect x="13" y="6" width="3" height="15" fill="currentColor" opacity="0.8" />
            <rect x="18" y="12" width="3" height="9" fill="currentColor" opacity="0.9" />
        </svg>
    );
}

// ============ CHAT ICONS ============

export function CommunityChatIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Chat bubble */}
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            {/* Multiple users dots */}
            <circle cx="9" cy="10" r="1.5" fill="currentColor" />
            <circle cx="12" cy="10" r="1.5" fill="currentColor" />
            <circle cx="15" cy="10" r="1.5" fill="currentColor" />
        </svg>
    );
}

export function AdminSupportIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Chat bubble */}
            <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
            {/* Shield overlay */}
            <path d="M12 2l-3 1.5v3c0 2.5 3 4.5 3 4.5s3-2 3-4.5v-3L12 2z" fill="currentColor" opacity="0.2" />
            <path d="M12 2l-3 1.5v3c0 2.5 3 4.5 3 4.5s3-2 3-4.5v-3L12 2z" />
        </svg>
    );
}

export function ReplyIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Curved arrow (Telegram style) */}
            <path d="M9 14l-5-5 5-5" />
            <path d="M4 9h10.5a5.5 5.5 0 0 1 5.5 5.5v0a5.5 5.5 0 0 1-5.5 5.5H13" />
        </svg>
    );
}

export function BellIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            <path d="M13.73 21a2 2 0 0 1-3.46 0" />
        </svg>
    );
}

// ============ TRADING TOPIC ICONS ============

export function EntryIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Target circle */}
            <circle cx="12" cy="12" r="9" />
            <circle cx="12" cy="12" r="5" />
            <circle cx="12" cy="12" r="2" fill="currentColor" />
        </svg>
    );
}

export function StopLossIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Shield */}
            <path d="M12 2l-6 3v5c0 5 6 8 6 8s6-3 6-8V5l-6-3z" />
            {/* X inside */}
            <line x1="9" y1="9" x2="15" y2="15" />
            <line x1="15" y1="9" x2="9" y2="15" />
        </svg>
    );
}

export function TakeProfitIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Target */}
            <circle cx="12" cy="12" r="9" />
            <circle cx="12" cy="12" r="5" />
            {/* Check inside */}
            <path d="M9 12l2 2 4-4" strokeWidth="2.5" />
        </svg>
    );
}

export function AlertIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Bell */}
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
            {/* Lightning bolt */}
            <path d="M13 2l-2 7h4l-2 7" strokeWidth="2.5" />
        </svg>
    );
}

export function SupportResistanceIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Horizontal levels */}
            <line x1="3" y1="7" x2="21" y2="7" strokeWidth="2.5" />
            <line x1="3" y1="12" x2="21" y2="12" opacity="0.5" />
            <line x1="3" y1="17" x2="21" y2="17" strokeWidth="2.5" />
            {/* Touch points */}
            <circle cx="8" cy="7" r="1.5" fill="currentColor" />
            <circle cx="16" cy="7" r="1.5" fill="currentColor" />
            <circle cx="10" cy="17" r="1.5" fill="currentColor" />
            <circle cx="18" cy="17" r="1.5" fill="currentColor" />
        </svg>
    );
}

export function FibonacciIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Parallel retracement lines */}
            <line x1="4" y1="4" x2="20" y2="4" opacity="0.8" />
            <line x1="4" y1="8" x2="20" y2="8" opacity="0.6" />
            <line x1="4" y1="12" x2="20" y2="12" opacity="1" />
            <line x1="4" y1="16" x2="20" y2="16" opacity="0.6" />
            <line x1="4" y1="20" x2="20" y2="20" opacity="0.8" />
            {/* Vertical boundary */}
            <line x1="4" y1="4" x2="4" y2="20" strokeWidth="2" />
            <line x1="20" y1="4" x2="20" y2="20" strokeWidth="2" />
        </svg>
    );
}

export function ElliottWaveIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Wave curve with 5 impulse waves */}
            <path d="M2 12 L5 8 L8 14 L11 6 L14 16 L17 10 L20 14 L22 12" />
            {/* Wave points */}
            <circle cx="5" cy="8" r="1.5" fill="currentColor" />
            <circle cx="11" cy="6" r="1.5" fill="currentColor" />
            <circle cx="17" cy="10" r="1.5" fill="currentColor" />
        </svg>
    );
}

export function TradingViewIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Chart window */}
            <rect x="3" y="3" width="18" height="18" rx="2" />
            {/* Chart line */}
            <polyline points="7 14 10 10 13 12 17 8" strokeWidth="2.5" />
            {/* Toolbar dots */}
            <circle cx="6" cy="6" r="0.8" fill="currentColor" />
            <circle cx="9" cy="6" r="0.8" fill="currentColor" />
            <circle cx="12" cy="6" r="0.8" fill="currentColor" />
        </svg>
    );
}

export function MT4MT5Icon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Chart candlesticks */}
            <line x1="6" y1="8" x2="6" y2="16" />
            <rect x="5" y="10" width="2" height="4" fill="currentColor" />
            <line x1="11" y1="6" x2="11" y2="14" />
            <rect x="10" y="8" width="2" height="4" />
            <line x1="16" y1="10" x2="16" y2="18" />
            <rect x="15" y="12" width="2" height="4" fill="currentColor" />
            {/* Gear overlay */}
            <circle cx="18" cy="6" r="3" />
            <circle cx="18" cy="6" r="1.5" fill="currentColor" />
        </svg>
    );
}

export function StockIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Building */}
            <rect x="4" y="7" width="16" height="14" rx="1" />
            <line x1="9" y1="11" x2="9" y2="11.01" strokeWidth="3" />
            <line x1="15" y1="11" x2="15" y2="11.01" strokeWidth="3" />
            <line x1="9" y1="15" x2="9" y2="15.01" strokeWidth="3" />
            <line x1="15" y1="15" x2="15" y2="15.01" strokeWidth="3" />
            <rect x="10" y="18" width="4" height="3" fill="currentColor" />
            {/* Roof */}
            <path d="M4 7l8-4 8 4" />
        </svg>
    );
}

export function ForexIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Currency exchange arrows */}
            <circle cx="8" cy="8" r="5" />
            <circle cx="16" cy="16" r="5" />
            {/* Arrow from top-left to bottom-right */}
            <path d="M11 11l5 5" strokeWidth="2.5" />
            <polyline points="13 16 16 16 16 13" strokeWidth="2.5" />
            {/* Arrow from bottom-right to top-left */}
            <path d="M13 13l-5-5" strokeWidth="2.5" />
            <polyline points="11 8 8 8 8 11" strokeWidth="2.5" />
        </svg>
    );
}

export function IndexIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Gauge/speedometer */}
            <path d="M12 2a10 10 0 0 0-10 10h20A10 10 0 0 0 12 2z" />
            <circle cx="12" cy="12" r="2" fill="currentColor" />
            {/* Needle pointing up-right */}
            <path d="M12 12l5-5" strokeWidth="2.5" />
            {/* Tick marks */}
            <line x1="6" y1="8" x2="6" y2="6" opacity="0.6" />
            <line x1="12" y1="5" x2="12" y2="3" opacity="0.6" />
            <line x1="18" y1="8" x2="18" y2="6" opacity="0.6" />
        </svg>
    );
}

export function FCPOIcon({ className = "w-6 h-6" }) {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Chart line */}
            <polyline points="3 17 9 11 13 15 21 7" strokeWidth="1.8" />
            {/* Palm leaf */}
            <path d="M18 3c-2 2-2 5-2 5s3 0 5-2" fill="currentColor" opacity="0.3" />
            <path d="M18 3c-2 2-2 5-2 5s3 0 5-2" />
            <path d="M16 8c1-1 3-1 3-1s0 2-1 3" opacity="0.6" />
        </svg>
    );
}
